import React from 'react';
import { motion } from 'framer-motion';
interface StorySectionProps {
  title?: string;
  children: React.ReactNode;
  imageSrc?: string;
  imageAlt?: string;
  imageCaption?: string;
}
export function StorySection({
  title,
  children,
  imageSrc,
  imageAlt,
  imageCaption
}: StorySectionProps) {
  return <section className="mb-10" data-id="element-255">
      {title && <h3 className="text-2xl font-bold text-gray-900 mb-4 font-serif" data-id="element-256">
          {title}
        </h3>}

      {imageSrc && <motion.figure initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="my-8" data-id="element-257">
          <img src={imageSrc} alt={imageAlt || ''} className="w-full rounded-lg shadow-md mb-2" data-id="element-258" />
          {imageCaption && <figcaption className="text-sm text-gray-500 text-center italic" data-id="element-259">
              {imageCaption}
            </figcaption>}
        </motion.figure>}

      <div className="text-lg text-gray-800 leading-relaxed space-y-6" data-id="element-260">
        {children}
      </div>
    </section>;
}